import { styled } from '@elliemae/ds-system';
import { DSTabsName, TABS_SLOTS } from '../../constants/index.js';

export const StyledTabsContainer = styled('div', { name: DSTabsName, slot: TABS_SLOTS.TABS_CONTAINER })`
  display: flex;
  flex-direction: column;
`;
export const StyledTabBarContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  overflow-x: hidden;
`;
